import { ROUTES } from "@/constants/routes"
import { FAQPage, WithContext } from "schema-dts"

export const jsonLd: WithContext<FAQPage> = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
        {
            "@type": "Question",
            name: "What are AI summaries?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "AI Summaries are generated using a mix of fine-tuned AI models and proprietary methods to generate high-quality concise or detailed summaries. The best way to create summaries is with our browser extension - don’t miss it! <a href='https://chromewebstore.google.com/detail/recall-summarize-anything/ldbooahljamnocpaahaidnmlgfklbben?hl=en'>Chrome Extension</a>",
            },
        },
        {
            "@type": "Question",
            name: "What content can you summarize?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "Recall works best on: YouTube Videos with a transcription, PDFs, Articles, Google Docs, Blogs, Recipes. We are quickly expanding the content we support - if you have a request please add it to our <a href='https://recall.canny.io/'>roadmap</a>.",
            },
        },
        {
            "@type": "Question",
            name: "How do I cancel, change plans, or change credit cards?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "You can manage your subscription from the 'Manage Subscription' section found in the main app menu.",
            },
        },
        {
            "@type": "Question",
            name: "Do you offer refunds?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "Yes, if you are not satisfied with our product within the first 30 days, we will refund you.",
            },
        },
        {
            "@type": "Question",
            name: "What are unlimited personal notes?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "You can use Recall as you would any other note-taking system. Simply create an unlimited amount of your own notes in Recall. Select an empty card from the drop-down menu in the app. You can also generate quiz questions on your personal notes!",
            },
        },
        {
            "@type": "Question",
            name: "What are AI quiz questions?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "For all the cards you save into Recall, you can generate a quiz! This is part of our goal to enable long-term retention of content you care about. You can also fully customize these questions - adding more manually or changing the answers.",
            },
        },
        {
            "@type": "Question",
            name: "What is Automatic categorization?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "All AI summaries that you save into Recall have an automatic tag added to it which categorizes the card in the left panel of the application. This category is unique to you and existing tags you have.",
            },
        },
        {
            "@type": "Question",
            name: "What is Automatic knowledge graph creation?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "This is where the magic really happens! All the AI summaries that you save into Recall have keywords extracted and linked, enabling you to form connections to related content that you otherwise would have missed. Learn more about the origins of graph databases in our blog.",
            },
        },
        {
            "@type": "Question",
            name: "What language do you support?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "You can translate AI summaries and your quiz questions to any of the following languages: English, German, French, Spanish, Italian, Chinese, Japanese, Korean, Portuguese, Russian.",
            },
        },
        {
            "@type": "Question",
            name: "Student Discounts?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "Yes, please email us at support@getrecall.ai from your student email address for a 20% student discount.",
            },
        },
        {
            "@type": "Question",
            name: 'What does "Unlimited" mean in Recall&apos;s pricing?',
            acceptedAnswer: {
                "@type": "Answer",
                text: `Our Unlimited Plan gives you extensive access to Recall&apos;s features, but like any service, it is subject to reasonable usage limits. Excessive usage may require a review. Please see our <a href='${ROUTES.FAIR_USE_POLICY}'>Fair Use Policy</a> for details.`,
            },
        },
        {
            "@type": "Question",
            name: " Where can I find the full Terms of Service and Fair Use Policy?",
            acceptedAnswer: {
                "@type": "Answer",
                text: `You can read our full <a href='${ROUTES.TERMS_OF_SERVICE}'>Terms of Service</a> and <a href='${ROUTES.FAIR_USE_POLICY}'>Fair Use Policy</a> for details on usage, payments, and service policies.`,
            },
        },
    ],
}
